import { IHttpService, IPromise } from "angular";
import { OnboardingApplicationStatusRM } from "@herbjoy/apex-api-models";

export class OnboardingStatusService {
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject'
    }

    /**
     * Retrieve all onboarding application statuses the are available to be selected
     * for the application with the given ID.
     * @param {Number} onboardingApplicationID
     */
    retrieveAvailableStatuses(onboardingApplicationID: number): IPromise<OnboardingApplicationStatusRM> {
        return this.$http<OnboardingApplicationStatusRM>({
            method: "GET",
            url: this.apexApiUrl + "onboarding-applications/" + onboardingApplicationID + "/available-statuses",
            headers: { Accept: "application/json" }
        })
            .then(function (response) {
                return response.data;
            })
    }
}
